<script setup lang="ts">
import { TextValueDto } from '@/api/generator';

import type { TextValueProps } from '../types';
import TextField from '../TextField/TextField.vue';

const props = defineProps<TextValueProps>();

const emits = defineEmits<{
  'update:modelValue': [TextValueDto];
}>();

function onUpdate(value: string | undefined) {
  if (props.modelValue) {
    emits('update:modelValue', { ...props.modelValue, value });
  }
}
</script>

<template>
  <TextField
    v-bind="props"
    :modelValue="typeof modelValue?.value === 'string' ? modelValue?.value : undefined"
    :mode="mode"
    @update:modelValue="onUpdate"
  />
</template>
